import type { PieceChar } from '@strategy4kids/protocol';

/** 64-length board array; index = rankIndex * 8 + fileIndex (rankIndex 0 = rank 8). */
export type Placement = (PieceChar | null)[];

export function squareToIndex(sq: string): number {
  const file = sq.charCodeAt(0) - 97;
  const rank = 8 - Number(sq[1]);
  return rank * 8 + file;
}

export function indexToSquare(i: number): string {
  const file = i % 8;
  const rank = 8 - Math.floor(i / 8);
  return `${String.fromCharCode(97 + file)}${rank}`;
}

export function parsePlacement(fen: string): Placement {
  const rankPart = fen.split(' ')[0] ?? '';
  const placement: Placement = new Array(64).fill(null);
  let i = 0;
  for (const ch of rankPart) {
    if (ch === '/') continue;
    if (/\d/.test(ch)) {
      i += Number(ch);
      continue;
    }
    placement[i] = ch as PieceChar;
    i += 1;
  }
  return placement;
}

export function colorOf(char: PieceChar): 'w' | 'b' {
  return char === char.toUpperCase() ? 'w' : 'b';
}

export function isWhite(char: PieceChar): boolean {
  return colorOf(char) === 'w';
}
